export const ADMIN = 'Admin';
export const DISPATCHER = 'Dispatcher';
export const FINANCE = 'Finance';

export const userRolesDropdown = [
    { label: 'Admin', value: ADMIN },
    { label: 'Dispatcher', value: DISPATCHER },
    { label: 'Finance', value: FINANCE },
];
